import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import { Injectable } from '@angular/core';
import { defaultLocale, LanguageCode } from './language.model';

@Injectable({ providedIn: 'root' })
export class LocaleService {
  private _currentLocale: LanguageCode = defaultLocale;

  constructor() {
    this.setLocale(this._currentLocale);
  }

  get currentLocale() {
    return this._currentLocale;
  }

  setLocale(locale: LanguageCode) {
    this.loadLocaleData(locale);
    this._currentLocale = locale;
  }

  private loadLocaleData(locale: LanguageCode) {
    switch (locale) {
      case 'fr':
        registerLocaleData(localeFr);
        break;
      case 'fr-qc': {
        registerLocaleData(localeFr);
        break;
      }
      case 'es':
        registerLocaleData(localeEs);
        break;
      case 'es-sa':
        registerLocaleData(localeEs);
        break;
      case 'en':
      default:
        registerLocaleData(localeEn);
        break;
    }
  }
}
